import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import { hashHistory } from "react-router";

import { CardElement, injectStripe } from 'react-stripe-elements';
import { message, Spin } from "antd";

import { postPayment, postCardToConnectedAccountStripe } from "../../services/firebase/firebase";
import { popupPaymentStore, selectPaymentEvent } from "../../actions/optionsStoreActions";

const defaultErrorMessage = 'Sorry, currently we have a problem with server. Please try later.';

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      loading: false,
    };
  }

  onCompleteCheckout(e) {
    e.preventDefault();

    const { user, itemId, eventCost, formType } = this.props;
    const type = 'event_subscription';

    this.setState({ loading: true });
    this.props.stripe.createToken({ currency: 'usd' })
      .then(payload => {
        if (payload.error) {
          message.error(payload.error.message);

          this.setState({ loading: false });
        } else {
          if (payload.token && formType === 'addCard' && user && user.userData && user.userData.stripeAccountId) {
            postCardToConnectedAccountStripe(payload.token, user.uid, user.userData.stripeAccountId)
              .then((res) => {
                if (res.succeeded || res.pending) {
                  this.setState({ loading: false });
                  message.success('Thank you! Card added to your profile.');

                  hashHistory.push(`/Profile`);
                  this.props.popupPaymentStore(false);
                  this.props.selectPaymentEvent('');
                } else {
                  this.setState({ loading: false });
                  message.error(`Error: ${(res.error && res.error.message) || defaultErrorMessage}`)
                }
              })
              .catch((error) => {
                this.setState({ loading: false });
                message.error('Error', error.message || error)
              });
          };

          if (payload && payload.token && formType === 'payment') {
            postPayment(payload.token, user.uid, itemId, eventCost, type)
              .then((res) => {
                if (res.succeeded || res.pending) {
                  this.setState({ loading: false });
                  message.success('Thank you! Event added to your profile.');

                  hashHistory.push(`/watch/${itemId}`);
                  this.props.popupPaymentStore(false);
                  this.props.selectPaymentEvent('');
                } else {
                  this.setState({ loading: false });
                  message.error(`Error: ${(res.error && res.error.message) || defaultErrorMessage}`)
                }
              })
              .catch((error) => {
                this.setState({ loading: false });
                message.error('Error', error.message || error)
              })
          }
        }
      })
      .catch((error) => {
        message.error('Error: We have problem with connecting to stripe system', error)
      });
  };

  render() {
    const { formType, user } = this.props;
    const { loading } = this.state;
    const isHaveUserData = !!(user && user.userData);

    return (
      <div className="checkout">
        <form onSubmit={(e) => this.onCompleteCheckout(e)}>
          {
            !isHaveUserData && (
              <p className="warning-description">
                Welcome to the app! Please, visit your
                <span className="link-style" onClick={() => hashHistory.push(`/profile`)}>profile</span>
                and update your information.
              </p>
            )
          }

          {
            formType === 'payment' && (
              <p>Enter your card information below:</p>
            )
          }

          {
            formType === 'addCard' && (
              <p>For adding a card to your account, please be sure that it's a debit card and this card has a USD currency.</p>
            )
          }

          <CardElement />

          {
            formType === 'payment' && (
              <button
                className={`button ${!isHaveUserData ? 'disabled' : ''}`}
                disabled={loading || !isHaveUserData}
              >
                Pay
              </button>
            )
          }
          {
            formType === 'addCard' && (
              <button disabled={loading}>Add</button>
            )
          }
        </form>

        {
          loading && (
            <div className="preloader-wr">
              <Spin className="preloader" />
            </div>
          )
        }
      </div>
    );
  }
}

export default connect(
  null,
  {
    popupPaymentStore, selectPaymentEvent
  }
)(injectStripe(CheckoutForm));



// WEBPACK FOOTER //
// ./src/components/payment/CheckoutForm.js